import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  GetChartResponse,
  IGetSensorDetailChartRequest,
  IGetSensorDetailFullChartRequest,
  IGetSensorMetricsRequest,
} from './SensorDetails.type';
import { SensorsApi } from 'services';
import {
  GET_SENSOR_CHART_REQUEST,
  GET_SENSOR_FULL_CHART_REQUEST,
  GET_SENSOR_METRICS_REQUEST,
} from './SensorDetails.constant';
import {
  getSensorDetailChartFailure,
  getSensorDetailChartSuccess,
  getSensorDetailFullChartFailure,
  getSensorDetailFullChartSuccess,
  getSensorMetricsFailure,
  getSensorMetricsSuccess,
} from './SensorDetails.action';

function* workerGetSensorChart({ payload }: IGetSensorDetailChartRequest) {
  try {
    const data: { data: GetChartResponse } = yield call(
      SensorsApi.getSensorChart,
      payload,
    );

    yield put(getSensorDetailChartSuccess(data.data));
  } catch (error) {
    yield put(getSensorDetailChartFailure(error));
  }
}

function* watchGetSensorChart() {
  yield takeLatest(GET_SENSOR_CHART_REQUEST, workerGetSensorChart);
}

function* workerGetSensorFullChart({
  payload,
}: IGetSensorDetailFullChartRequest) {
  try {
    const data: { data: unknown } = yield call(
      SensorsApi.getSensorFullChart,
      payload,
    );

    yield put(getSensorDetailFullChartSuccess(data.data));
  } catch (error) {
    yield put(getSensorDetailFullChartFailure(error));
  }
}

function* watchGetSensorFullChart() {
  yield takeLatest(GET_SENSOR_FULL_CHART_REQUEST, workerGetSensorFullChart);
}

function* workerGetSensorMetrics({ payload }: IGetSensorMetricsRequest) {
  try {
    const data: { data: unknown } = yield call(
      SensorsApi.getSensorMetrics,
      payload,
    );

    yield put(getSensorMetricsSuccess(data.data));
  } catch (error) {
    yield put(getSensorMetricsFailure(error));
  }
}

function* watchGetSensorMetrics() {
  yield takeLatest(GET_SENSOR_METRICS_REQUEST, workerGetSensorMetrics);
}

export const sensorDetailsWatchers = [
  fork(watchGetSensorChart),
  fork(watchGetSensorFullChart),
  fork(watchGetSensorMetrics),
];
